// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ProcessedColorValue, ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double, WithDefault } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
type OneNativeStyleNative = Readonly<{
  fontSize?: WithDefault<Double, -1>;
  fontWeight?: string;
  fontDesign?: string;
  textStyle?: string;
  foregroundStyle?: ProcessedColorValue;
  tint?: ProcessedColorValue;
  background?: ProcessedColorValue;
  padding?: WithDefault<Double, -1>;
  paddingTop?: WithDefault<Double, -1>;
  paddingLeading?: WithDefault<Double, -1>;
  paddingBottom?: WithDefault<Double, -1>;
  paddingTrailing?: WithDefault<Double, -1>;
  width?: WithDefault<Double, -1>;
  height?: WithDefault<Double, -1>;
  minWidth?: WithDefault<Double, -1>;
  idealWidth?: WithDefault<Double, -1>;
  maxWidth?: WithDefault<Double, -1>;
  minHeight?: WithDefault<Double, -1>;
  idealHeight?: WithDefault<Double, -1>;
  maxHeight?: WithDefault<Double, -1>;
  cornerRadius?: WithDefault<Double, -1>;
  opacity?: WithDefault<Double, -1>;
  borderColor?: ProcessedColorValue;
  borderWidth?: WithDefault<Double, -1>;
  glassEffect?: string;
  glassEffectInteractive?: boolean;
  glassEffectTint?: ProcessedColorValue;
  glassEffectShape?: string;
  material?: string;
  sdkModifiers?: string;
}>;
interface NativeProps extends ViewProps {
  url: string;
  html: string;
  script: string;
  command: string;
  commandRevision: Double;
  commandValue: string;
  limitsNavigationsToAppBoundDomains: boolean;
  inlineMedia: boolean;
  inspectable: boolean;
  bounces: boolean;
  backForwardNavigationGestures: string;
  magnificationGestures: string;
  linkPreviews: string;
  elementFullscreen: string;
  contentBackground: string;
  swiftStyle?: OneNativeStyleNative;
  onNativeSDKEvent?: DirectEventHandler<Readonly<{
    name: string;
    value: string;
  }>>;
  onNativeWebViewNavigate?: DirectEventHandler<Readonly<{
    url: string;
    eventCount: Int32;
  }>>;
  onNativeWebViewTitleChange?: DirectEventHandler<Readonly<{
    title: string;
    eventCount: Int32;
  }>>;
  onNativeWebViewLoadingChange?: DirectEventHandler<Readonly<{
    loading: boolean;
    progress: Double;
    eventCount: Int32;
  }>>;
  onNativeWebViewLoadStart?: DirectEventHandler<Readonly<{
    eventCount: Int32;
  }>>;
  onNativeWebViewLoadEnd?: DirectEventHandler<Readonly<{
    eventCount: Int32;
  }>>;
  onNativeWebViewError?: DirectEventHandler<Readonly<{
    message: string;
    eventCount: Int32;
  }>>;
  onNativeWebViewHttpError?: DirectEventHandler<Readonly<{
    statusCode: Double;
    eventCount: Int32;
  }>>;
  onNativeWebViewMessage?: DirectEventHandler<Readonly<{
    data: string;
    eventCount: Int32;
  }>>;
  onNativeWebViewHistoryChange?: DirectEventHandler<Readonly<{
    canGoBack: boolean;
    canGoForward: boolean;
    eventCount: Int32;
  }>>;
  onNativeWebViewProcessTerminate?: DirectEventHandler<Readonly<{
    eventCount: Int32;
  }>>;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
let nativeComponentName = 'OneNativeWebView';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeWebView",
  directEventTypes: {
    topNativeSDKEvent: {
      registrationName: "onNativeSDKEvent"
    },
    topNativeWebViewNavigate: {
      registrationName: "onNativeWebViewNavigate"
    },
    topNativeWebViewTitleChange: {
      registrationName: "onNativeWebViewTitleChange"
    },
    topNativeWebViewLoadingChange: {
      registrationName: "onNativeWebViewLoadingChange"
    },
    topNativeWebViewLoadStart: {
      registrationName: "onNativeWebViewLoadStart"
    },
    topNativeWebViewLoadEnd: {
      registrationName: "onNativeWebViewLoadEnd"
    },
    topNativeWebViewError: {
      registrationName: "onNativeWebViewError"
    },
    topNativeWebViewHttpError: {
      registrationName: "onNativeWebViewHttpError"
    },
    topNativeWebViewMessage: {
      registrationName: "onNativeWebViewMessage"
    },
    topNativeWebViewHistoryChange: {
      registrationName: "onNativeWebViewHistoryChange"
    },
    topNativeWebViewProcessTerminate: {
      registrationName: "onNativeWebViewProcessTerminate"
    }
  },
  validAttributes: {
    url: true,
    html: true,
    script: true,
    command: true,
    commandRevision: true,
    commandValue: true,
    limitsNavigationsToAppBoundDomains: true,
    inlineMedia: true,
    inspectable: true,
    bounces: true,
    backForwardNavigationGestures: true,
    magnificationGestures: true,
    linkPreviews: true,
    elementFullscreen: true,
    contentBackground: true,
    swiftStyle: true,
    ...ConditionallyIgnoredEventHandlers({
      onNativeSDKEvent: true,
      onNativeWebViewNavigate: true,
      onNativeWebViewTitleChange: true,
      onNativeWebViewLoadingChange: true,
      onNativeWebViewLoadStart: true,
      onNativeWebViewLoadEnd: true,
      onNativeWebViewError: true,
      onNativeWebViewHttpError: true,
      onNativeWebViewMessage: true,
      onNativeWebViewHistoryChange: true,
      onNativeWebViewProcessTerminate: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);